import { AfterViewInit, Component, EventEmitter, HostListener, input, Input, OnInit, output, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Statement } from 'src/app/ballot/backend-types';
import { MatDialog } from '@angular/material/dialog';
import { WriteInDialogComponent } from '../write-in-dialog/write-in-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
    selector: 'app-ranked-choice',
    imports: [MatIconModule, MatButtonModule, MatTooltipModule],
    templateUrl: './ranked-choice.component.html',
    styleUrl: './ranked-choice.component.scss'
})
export class RankedChoiceComponent implements OnInit {
  ranked = input.required<Statement>()
  @Input() index: number = 0;
  isMobileScreen = this.breakpointObserver.isMatched('(max-width:1000px)');
  moveUp = output<Statement>();
  moveDown = output<Statement>();
  tooltipText = $localize`Click for additional information`;

  constructor(private breakpointObserver: BreakpointObserver, private readonly dialog: MatDialog) { }

  ngOnInit() {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width:1000px)');
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = this.breakpointObserver.isMatched('(max-width:1000px)');
  }

  onMoveUp() {
    this.moveUp.emit(this.ranked());
  }

  onMoveDown() {
    this.moveDown.emit(this.ranked());
  }

  onWriteInEdit() {
    this.openWriteInDialog()
  }


  disableRankUpButton() {
    let buttonUp: HTMLButtonElement
    if (this.isMobileScreen) {
      buttonUp = document.querySelector(`#rankUpMobile${this.index}`) as HTMLButtonElement;
    }
    else {
      buttonUp = document.querySelector(`#rankUpDesktop${this.index}`) as HTMLButtonElement;
    }
    if (buttonUp) {
      buttonUp.disabled = true;
    }
  }


  enableRankUpButtons(){
    let buttonUp: HTMLButtonElement
    if (this.isMobileScreen) {
      buttonUp = document.querySelector(`#rankUpMobile${this.index}`) as HTMLButtonElement;
    }
    else {
      buttonUp = document.querySelector(`#rankUpDesktop${this.index}`) as HTMLButtonElement;
    }
    if (buttonUp) {
      buttonUp.disabled = false;
    }
  }

  openWriteInDialog() {
    const dialogRef = this.dialog.open(WriteInDialogComponent, {
      width: '350px',
      data: {
        description: this.ranked().description,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.result) {
        if (this.ranked) {
          this.ranked().description = result.result
        }
      }
    });
  }

  isStringEmpty(value: string | null | undefined): boolean {
    return (value == null || (typeof value === "string" && value.trim().length === 0));
  }

  isImage(url?: string): boolean {
    const imageEndings = ['png', 'svg', 'jpg', 'jpeg']
    if (url) {
      const ending = url.split('.').pop()
      return (ending) ? imageEndings.includes(ending) : false
    } else {
      return false
    }
  }

}
